export default {
  en: {
    中文: 'English',
    登录: 'Log in',
    请输入: 'Please Enter',
    请选择:'Please Select ',
    未提交: 'Not submitted',
    待审核: 'To be reviewed',
    拒绝: 'Refuse',
    通过: 'Pass',
    再次提交: 'Resubmit',
    等待审核:'Waiting For Approval',
    提交成功: 'Submitted successfully',
    提交:'Submit',
    搜索: 'Search',
    保存: 'Save',
    保存成功: 'Save succeeded',
    刷新: 'Refresh',
    添加: 'Add',
    添加成功: 'Successfully added',
    编辑: 'Edit',
    编辑成功: 'Edit succeeded',
    删除: 'Delete',
    删除成功: 'Deletion succeeded',
    '数据导出中...':'Data Exporting...',

    重置: 'Reset',
    确定: 'Confirm',
    取消: 'Cancel',
    关闭: 'Close',
    关闭其他: 'Close Other',
    上架状态:'On Shelf Status',
    待上架:'To Be Hit The Shelves',
    待上架全部上架:'To Be Hit The Shelves',
    全部上架成功:'All Successfully',
    上架: 'Hit The Shelves',
    下架: 'Pull off Shelves',
    热门: 'Hot',
    非热门: 'Not Hot',
    取消热门: 'Cancel Hot',
    状态: 'Status',
    操作: 'Operation',
    更新时间: 'Update Time',
    创建时间: 'Creation Time',
    创建开始时间: 'Creation Start Time',
    至: 'To',
    创建结束时间: 'Creation End Time',
    开始时间: 'Start Time',
    结束时间: 'End Time',
    最近一周: 'Last week',
    最近一个月: 'Last month',
    最近三个月: 'Last three months',
    序号: 'Serial Number',
    一级分类: 'First Classification',
    二级分类: 'Secondary Classification',
    三级分类: 'Third Classification',
    请上传文件:'Please Upload File',
    '将文件拖到此处，或':'Drag files here, or',
    点击上传:'Click Upload',
    图片裁剪:'Photo Cropping',
    上传图片: 'Upload Photo',
    上传证书: 'Upload Certificate',
    上传视频: 'Upload Video',
    '服务器开了小差，请稍后再试': 'The server has left, please try again later',
    视频格式错误: 'Video format error',
    视频大小不能超过10MB: 'Video size cannot exceed 10MB',
    视频大小不能超过2MB: 'Video size cannot exceed 2MB',
    图片上传中: 'Image Uploading',
    文件上传中:'File Uploading',
    视频上传中: 'Video Uploading',
    上传成功: 'Upload Succeeded',
    上传失败: 'Upload Failed',
    备注: 'Remarks',
    已完成: 'Completed',
    未完成: 'Unfinished',
    提示: 'Tips',
    昵称: 'Nickname',
    手机号码: 'Phone Number',
    '操作成功，数据正在异步导入中':'Operation succeeded. Data is being imported asynchronously',

    '请输入商品名称【品牌名(中文/英文)+产品名称(成色/材质/品类/元素/款式/系列)+附加产品特点】(例:爱恋ailian18K金镶红宝石情侣对戒促销款)': 'Please enter the product name [brand name (Chinese/English)+product name (quality/material/category/element/style/series)+additional product features] (example: love ailian18K gold inlaid ruby couple ring promotional)',
    '请输入商品规格(基本属性:(材质、功能、特征、风格)+规格参数:(型号、颜色、尺寸、规格、用途、货号)(例:18K 镶嵌1 克拉钻定制手寸 logo刻字)': 'Please enter the product specification (basic attributes: (material, function, feature, style)+specification parameters: (model, color, size, specification, purpose, article number)(for example: 18K inlaid 1-carat diamond custom logo engraving)',
    供应宝商家工作台: 'Supplyzm Merchant Workbench',
    '深圳钻明网络运营有限公司 出品':'Shenzhen Zuanming Internet Operation Co.,ltd',
    账号: 'Account',
    密码: 'Password',
    验证码: 'Verify Code',
    出品: 'Product',
    修改密码: 'Change Password',
    新密码: 'New Password',
    确认密码: 'Confirm Password',
    退出登录: 'Log out',
    首页: 'Home page',
    今日浏览数: 'Views today',
    今日订单数: 'Orders today',
    今日收藏商品数: 'Number of collections today',
    今日关注商家数: 'Number of concern merchants today',
    浏览总数: 'Total views',
    报关订单总数: 'Total customs declaration orders',
    收藏商品总数: 'Total collections',
    关注商家总数: 'Total number of concern merchants',
    代办事项: 'Pending Items',

    商家管理: 'Suppliers Management',
    商家信息: 'Suppiers Information',
    注册账号: 'Registration Account',
    企业名称: 'Enterprise Name',
    企业资质: 'Enterprise Qualification',
    业务范围: 'Scope of Business',
    金融服务: 'Financial Service',
    报关服务: 'Customs Declaration Service',
    商家服务: 'Supplier & Commodity Service',
    审核时间: 'Audit Time',
    经营范围: 'Nature of Business',
    裸石类: 'Loose Diamond',
    天然钻:'Natural diamond',
    培育钻:'Lab grown diamond',
    其他: 'Other',
    联系人: 'Contact Person',
    企业所在地:'Location Of An Enterprise',
    企业详细地址:'Enterprise Address',
    审核状态: 'Audit Status',
    到期时间: 'Expiration Time',
    企业简介: 'Enterprise Profile',
    国家:'Country',
    省:'Province',
    市:'City',
    区:'District',
    企业定位:'Enterprise Location',
    经度:'Longitude',
    纬度:'Latitude',
    当前经度:'Current Longitude',
    当前纬度:'Current Latitude',
    地址:'Address',
    当前地址:'Current Address',
    选择定位:'Choose Location',
    暂无数据:'No Data',
    请输入城市:'Please Enter The City',
    请输入关键字:'Please Enter The Keyword',
    境内:'Within China',
    境外:'Outside China',
    '未匹配到经纬度，请点击选择定位':'The longitude and latitude are not matched, please click to select positioning',

    珠宝商品: 'Jewelry Products',
    品牌: 'Brand',
    最低人民币: 'Lowest Price',
    到: 'To',
    最高人民币: 'Highest Price ',
    商品名称: 'Commodity Name',
    商品规格: 'Commodity Specifications',
    商品编码: 'Commodity Code',
    计价类型:'Pricing Type',
    金工石计价:'Pricing of metalwork stone',
    一口价:'Price',
    选择材质: 'Select Material',
    材质:'Material',
    选择成色: 'Choose A Quality',
    成色:'Fineness',
    '18K金': '18K Gold',
    '14K金': '14K Gold',
    '9K金': '9K Gold',
    成色值:'Fineness Value',
    镶嵌类:'Inlays',
    玉石类:'Jade',
    银饰类:'Silver',
    黄金类:'Gold',
    铂全类:'Platinum',
    K金类:'Karat Gold',
    珍珠类:'Pearl',
    宝石类:'Gemstone',
    辅材类:'Accessories',
    其他:'Others',
    克重:'Gram Weight',
    联系电话:"Phone Number",
    料价:'Material Price',
    主石金额:'Main Stone Price',
    '精品工费/克':'Premium labor cost/g',
    '基础工费/克':'Basic labor cost/g',
    '工费/件':'Labor cost/piece',
    商品价格: 'Commodity Price',
    商品美元价格: 'Commodity USD Price',
    商品人民币价格: 'Commodity CNY Price',
    商品分类: 'Commodity Classification',
    商品品牌: 'Commodity Brand',
    点击数: 'Click Numbers',
    收藏数: 'Collectible  Quantity',
    商品状态: 'Commodity Status',
    热门状态: 'Hot Status',
    请输入正确的最小人民币金额: 'Please input The Commodity Lowest Price',
    请输入正确的最大人民币金额: 'Please Input The Commodity Highest Price',
    最大人民币金额必须大于最小人民币金额: 'Highest Price must be greater than Lowest Price',
    请先选择珠宝商品: 'Please select jewelry products first',
    金额不能为空: 'Amount cannot be blank',
    商品价格需大于0: 'Commodity price must be greater than 0',
    请输入正确金额: 'The amount cannot be blank. Please enter the correct amount',
    已全部: 'All',
    已上架: 'Hit The Shelves',
    已下架: 'Pull off Shelves',
    选中已上架:'Selected On Shelf',
    选中已下架:'Selected Off Shelf',
    已取消热门: 'Hot canceled',
    已设置为热门: 'Set as hot',
    设置为热门: 'Set as hot',
    取消热门: 'Cancel Hot',
    基本信息: 'Basic Information',
    商品主图: 'Commodity Main Photo',
    封面图: 'Cover Photo',
    商品详情: 'Commodity Details',
    商品详情图: 'Commodity Details Photo',
    '图片:每张大小在300KB以内,格式为ipg/png,建议尺寸800*800，图片尽量底色保持纯色背景': 'Picture: Each picture is within 300KB in size, ipg/png format, 800 * 800 is recommended, and the background color of the picture should be kept as solid as possible',
    '视频:限1个，大小10M以内，格式Mp4，建议尺寸800*800px，3-10秒，画质清晰最优为360度，尽量底色保持纯色背景': 'Video: limited to 1, the size is less than 10M, the format is Mp4, the recommended size is 800 * 800px, 3-10 seconds, the image quality is preferably 360 degrees, and the background color should be kept as solid as possible',
    '视频:限1个，大小2M以内，格式Mp4，建议尺寸800*800px，3-10秒，画质清晰最优为360度，尽量底色保持纯色背景': 'Video: limited to 1, the size is less than 2M, the format is Mp4, the recommended size is 800 * 800px, 3-10 seconds, the image quality is preferably 360 degrees, and the background color should be kept as solid as possible',
    珠宝品牌: 'Jewelry Brand',
    服务到期日期: 'Service expiration date',
    料价汇率到期日期: 'Gram price expiration date',
    到期:"expire",
    置顶状态: 'The Top State',
    置顶: 'Stick on top',
    非置顶: 'Not On Top',
    取消置顶: 'Cancel On Top',
    品牌: 'Brand',
    品牌名称: 'Brand Name',
    品牌英文名: 'Brand English Name',
    品牌图片: 'Brand Logo',
    不输入则自动生成品牌对应的拼音名: 'If not entered, the pinyin name corresponding to the brand will be generated automatically',
    品牌备注: 'Brand Remark',
    请先选择珠宝品牌: 'Please select jewelry brand first',

    导入:'Import ',
    "导出 ":'Export ',
    导出筛选数据:'Export ',
    文件:'File',
    白钻: 'White Diamond',
    彩钻: 'Fancy Diamond',
    证书号: 'Certificate Number',
    证书编号: 'Certificate Number',
    证书货: 'Certificate Goods',
    散货: 'Parcel Goods',
    货号: 'Stock Number',
    形状: 'Shape',
    克拉: 'Carat',
    分数段: 'Fractional Segment',
    颜色: 'Color',
    色度: 'Color Degree',
    净度: 'Clarity',
    切工: 'Cut',
    抛光: 'Polish',
    对称: 'Symmetry',
    荧光: 'Fluorescence',
    奶色: 'Milky',
    咖色: 'Brown Tinch',
    证书: 'Certificate',
    所在地: 'Location',
    地点: 'Location',
    折扣: 'Discount',
    材质: 'Material',
    人民币: 'CNY',
    '人民币(必填)': 'CNY(Required)',
    美元: 'USD',
    '美元(必填)': 'USD(Required)',
    图片: 'Image',
    视频: 'Video',
    详情: 'Details',
    每卡单价: 'Unit price per card',
    国际报价: 'International Quotation of Price',
    '国际报价(必填)': 'International Quotation of Price(Required)',
    全深比: 'Overall Depth Ratio',
    台宽比: 'Abutment Width Ratio',
    尺寸: 'Size',
    净度特征: 'Clarity Characteristics',
    底尖: 'Bottom Cusp',
    冠角: 'Coronal Angle',
    冠高比: 'Crown Height Ratio',
    亭角: 'Pavilion Angle',
    亭深比: 'Pavilion Depth Ratio',
    奶咖绿: 'Milk Coffee Green',
    腰棱: 'Girdle',
    下腰小面比: 'Low Waist Small Face Ratio',
    星小面比: 'Star Facet Ratio',
    肉眼干净: 'Clean With Naked Eyes',
    出证日期: 'Date of Issue',
    '大小10M以内，格式Mp4，3-10 秒，画质清晰最优为 360 度，尽量底色保持纯色背景': 'The issuing date is within 10M, the format is Mp4, 3-10 seconds, the image quality is preferably 360 degrees, and the background color should be kept as solid as possible',
    '大小2M以内，格式Mp4，3-10 秒，画质清晰最优为 360 度，尽量底色保持纯色背景': 'The issuing date is within 2M, the format is Mp4, 3-10 seconds, the image quality is preferably 360 degrees, and the background color should be kept as solid as possible',
    请先选择商品: 'Please select goods first',
    无需保存数据: 'No need to save data',
    下载模板:'Download Version',
    模板选择:'Template Selection',
    供应宝模版:'Supplyzm Template',
    国际通用版:'International Version',
    模板类型:'Template Type',
    钻石类型:'Diamond Type',
    文件类型:'File Type',

    报关订单管理: 'Customs Declaration Order Management',
    报关订单: 'Customs Declaration Order',
    报关订单号: 'Customs Declaration Order Number',
    证书货清单: 'Certificate Goods List',
    订单状态: 'Order Status',
    散货清单: 'Parcel Goods List',
    供应商: 'Suppliers',
    数量: 'Quantity',
    颗: 'pcs',
    重量: 'Weight',
    创建订单时间: 'Order Creation Time',

    系统模块: 'System Management',
    管理员: 'Administrator',
    平台管理员: 'Platform Administrator',
    机构管理员: 'Institutional Administrator',
    校区管理员: 'Campus Administrator',
    企业管理员: 'Enterprise Administrator',
    角色管理: 'Role Management',
    权限: 'Authority',
    权限管理: 'Authority Management',
    '确定删除吗？': 'Are you sure to delete?',
    请输入名称: 'Please enter a name',
    禁用:'Disable',
    资源:'Resource',
    名称:'Name',
    元素:'element',
    角色:'Role',
    待绑定:'To be bind',
    已绑定:'Bind',
    解绑:'Unbinding',
    绑定:'binding',

    操作日志: 'Operation Log',
    模块名称: 'Module Name',
    搜索关键词: 'Search Keyword',
    操作功能: 'Operating Function',
    管理员账号: 'Administrator Account',
    查看详情: 'View Details',
    路由地址: 'Routing Address',
    描述: 'Describe',
    操作时间: 'Operate Time',
    请求方法: 'Request Method',

    料价汇率设置: 'Material Price Exchange Rate Setting',
    黄金: 'Gold',
    白银: 'Silver',
    铂金: 'Platinum',
    钯金: 'Palladium',
    美元人民币: 'USDCNY',
    离岸人民币: 'CNH',
    供应宝平台: 'Supplyzm Platform',
    同步供应宝平台: 'Synchronization Supplyzm Platform',
    汇率设置: 'Exchange rate settings',
    价格折扣调节功能: 'Price discount adjustment function',
    价格折扣调节: 'Price discount adjustment',
    '上浮输入正数，下调输入负数':'Float up to input positive numbers, and lower to input negative numbers',
    钻重区间: 'Drilling weight interval',
    '价格折扣调节功能只针对白钻和彩钻的数据，不影响散货数据': 'The price discount adjustment function is only applicable to the data of white diamonds and colored diamonds, and does not affect bulk cargo data',
    '商品价格以平台实时料价及汇率计算，商家也可选择开通商家汇率功能。开通此功能可自定义商家的料价及汇率，商品价格以商家自定义的料价及汇率计算。': `The commodity price is calculated based on the real-time material price and exchange rate of the platform, and merchants can also choose to open the merchant exchange rate function. By opening this function, you can customize the vendor's material price and exchange rate. The commodity price is calculated based on the vendor's user-defined material price and exchange rate.`,
    '输入内容需大于0': 'The input content must be greater than 0',

    统计管理: 'Statistical Management',
    商家统计: 'Merchants Statistics',
    关注客户账号: 'Concern Customers Account',
    关注开始日期: 'Start Date Of Concern',
    关注结束日期: 'End Date Of Concern',
    客户注册时间: 'Customer Registration Time',
    关注时间: 'The Time Of Concern',

    珠宝商品浏览统计: 'View Statistics Of Jewelry Products',
    珠宝商品名称: 'Jewelry Products Name',
    客户账号: 'Customers Account',
    浏览开始时间: 'Start Time Of View',
    浏览结束时间: 'End Time Of View',
    浏览客户账号: 'Customer Account of View',
    浏览时间: 'View Time',

    珠宝商品收藏统计: 'Collect Statistics Of Jewelry Products',
    收藏开始时间: 'Collectibles Start Time',
    收藏结束时间: 'Collectibles End Time',
    收藏客户账号: 'Customer Account Of Collectibles',
    收藏时间: 'Time Of Collectibles',

    裸石浏览统计: 'View Statistics Of Loose Diamond',
    裸石证书号: ' Certificate Number',
    或: 'or',
    散货编号: 'Parcel Number',
    裸石类型: 'Loose Diamond Type',

    裸石收藏统计: 'Collection Statistics Of Loose Diamond',
  }
}
